import React from 'react';
import Login from './Login';

import {login} from "../../redux/users/userActions";

import {Navigate} from 'react-router-dom';
import {connect} from "react-redux";

class LoginContainer extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			username: "",
			password: "",
			logged: false
		};
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		if(nextProps.ready && nextProps.logged){
			return {
				logged: true
			}
		} else if(nextProps.error) return {
			loading: false,
			error: nextProps.error
		};
		else return null;
	}

	onError(error) {
		this.setState({
			loading: false,
			error: error
		});
	}

	onSubmit = (e) => {
		e.preventDefault();
		this.setState({loading: true});
		this.props.onSubmit(this.state.username, this.state.password);
	};

	usernameListener = (e) => {
		this.setState({username: e.target.value});
	};

	passwordListener = (e) => {
		this.setState({password: e.target.value});
	};

	render() {
		if (this.state.logged) {
			return <Navigate to={"/"} />
		} else {
			return <Login isLoading={this.state.loading}
			              error={this.state.error}
			              username={this.state.username}
			              onUsernameChange={this.usernameListener}
			              password={this.state.password}
			              onPasswordChange={this.passwordListener}
			              onSubmit={this.onSubmit}/>;
		}
	}
}

function mapStateToProps({users}) {
	return {
		ready: users.ready,
		logged: users.isLogged,
		error: users.error
	};
}

const mapDispatchToProps = {login};

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer);
